import { Box, Chip, Paper, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface PlanSummaryCardProps {
    planName: string;
    benefits: string[];
}

export function PlanSummaryCard({
    planName,
    benefits,
}: PlanSummaryCardProps) {

    console.log(planName)
    console.log(benefits)

    const visibleBenefits = benefits?.length ? benefits : ["Flow Mobile phone line"];

    return (
        <Paper
            elevation={0}
            sx={{
                p: 1.8,
                borderRadius: "14px",
                border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.08)",
                bgcolor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.015)",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 18, color: "#15803d" }} />

                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 900,
                        color: "var(--fx-surface-text, #0F172A)",
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {planName}
                </Typography>

                <Chip
                    size="small"
                    label="Plan active"
                    sx={{
                        height: 22,
                        borderRadius: "999px",
                        bgcolor: "rgba(34,197,94,0.10)",
                        color: "#15803d",
                        fontSize: 11,
                        fontWeight: 800,
                        flexShrink: 0,
                    }}
                />
            </Box>

            <Typography
                sx={{
                    mt: 0.8,
                    fontSize: 13,
                    fontWeight: 500,
                    color: "var(--fx-surface-textsecondary, #64748B)",
                    lineHeight: 1.35,
                }}
            >
                {visibleBenefits.join(" · ")}
            </Typography>
        </Paper>
    );
}